import { render, staticRenderFns } from "./TaskReorderWordsCard.vue?vue&type=template&id=057fa906&scoped=true&"
import script from "./TaskReorderWordsCard.vue?vue&type=script&lang=ts&"
export * from "./TaskReorderWordsCard.vue?vue&type=script&lang=ts&"
import style0 from "./TaskReorderWordsCard.vue?vue&type=style&index=0&id=057fa906&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057fa906",
  null
  
)

export default component.exports